exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.jobs_wrapper[data-v-4cfd3ece] {\n  max-width: unset !important;\n}\n.setting_botton_top[data-v-4cfd3ece]{\n  position: absolute;\n  bottom: calc(100vh/4);\n  right: 0.5rem;\n  height: 50px;\n  padding: 16px;\n  display: none;\n  z-index: 1;\n  font-size: 120%;\n  font-weight: bold;\n}\n.setting_btn_print[data-v-4cfd3ece]{\n  position: absolute;\n  top: 0px;\n  right: 0.5rem;\n  height: 50px;\n  padding: 16px;\n  display: block;\n  z-index: 1;\n  font-size: 120%;\n  font-weight: bold;\n}\n", ""]);

// exports
